import "../Css/contactus.css";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const ContactUs = () => {

  const handleWhatsApp = (e) => {
    e.preventDefault();

    const name = e.target.name.value;
    const email = e.target.email.value;
    const phone = e.target.phone.value;
    const service = e.target.service.value;
    const message = e.target.message.value;

    const whatsappMessage = `
    Name: ${name}
    Email: ${email}
    Phone: ${phone}
    Service: ${service}
    Message: ${message}
`;

    const whatsappURL = `https://wa.me/917304398067?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappURL, "_blank");
  };

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="about-hero">
        <div className="about-overlay">
          <div className="about-hero-content">
            <h1>Contact Us</h1>
            <p>
              <span><a href="/">Home</a></span> /{" "}
              <span className="active">Contact Us</span>
            </p>
          </div>
        </div>
      </section>

      {/* ================= CONTACT SECTION ================= */}
      <section className="contactus">
        <div className="contactus-wrapper">

          {/* LEFT INFO */}
          <div className="contactus-left">
            <h2>Contact Us</h2>
            <p>
              Welcome to Tanya Maid Service your trusted partner for reliable maid
              services, making your home stress-free, clean, and comfortable.
            </p>

            <div className="contact-boxes">
              <div className="contact-box">
                <div className="icon">
  <FaPhoneAlt />
</div>

                <h4>Mobile Number</h4>
                <a
                  href="tel:+917304398067"
                  className="contact-link"
                >
                  +91 73043 98067
                </a>
              </div>

              <div className="contact-box">
                <div className="icon">
  <FaEnvelope />
</div>

                <h4>Email Address</h4>
                <a
                  href="mailto:info@tanyamaidservice.com"
                  className="contact-link"
                >
                  info@tanyamaidservice.com
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="contactus-form">
            <h2>Get In Touch</h2>

            <form onSubmit={handleWhatsApp}>
              <div className="form-row">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                />
              </div>

              <div className="form-row">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  required
                />

                <select name="service" required>
                  <option value="">Select Service</option>
                  <option>Patient Care</option>
                  <option>House Maid</option>
                  <option>Baby Care</option>
                  <option>Cooking</option>
                  <option>Driver</option>
                  <option>Home Cleaning</option>
                  <option>Japa Maid</option>
                </select>
              </div>

              <textarea
                name="message"
                placeholder="Your Message"
                required
              ></textarea>

              <button type="submit">SEND MESSAGE</button>
            </form>
          </div>

        </div>
      </section>

         <section className="contact-map">
        <iframe
          title="Tanya Maid Services Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7541.039524177508!2d72.90551!3d19.084841!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c78ca22b8b01%3A0x618abd782986f3b2!2sTANYA%20MAID%20SERVICES!5e0!3m2!1sen!2sin!4v1770359696044!5m2!1sen!2sin"
          loading="lazy"
          allowFullScreen
        ></iframe>
      </section>

    </>
  );
};

export default ContactUs;
